import { MobileSettingsData } from './mobile-settings-data';
import { AdalB2CData } from './adal-b2c-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class ApplicationSettingsData {
  ServerVersion: string;
  SmartHandover: MobileSettingsData;
  SmartInspector: MobileSettingsData;
  AppUrl: string;
  AppInsightKey: string;
  AdalB2CData: AdalB2CData;
  EulaVersion: string;
}


